import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: sessionStorage.getItem('state') ? JSON.parse(sessionStorage.getItem('state')) : {
    memberInfo: '',
    roleList: []
  },
  mutations: {
    setMemberInfo(state, val) {
      state.memberInfo = val;
      if (val.roleList != null && val.roleList.length > 0) {
        state.roleList = [];
        val.roleList.forEach(function (item, index) {
          state.roleList.push(item.roleCode)
        }) 
      }
    }
  },
  actions: {},
  modules: {}
})
